import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout, getCurrentUserId } from "../utils/auth";
import { getSidebarMenus } from "../constants/sidebarMenus";
import { useProfile } from "../hook/useProfile";
import TopHeader from "../components/comman/TopHeader";
import Sidebar from "../components/comman/Sidebar";
import "../css/Donation.css";
import xzy from "../assets/images/Coverpage.jpg";
import DonationSuccessIcon from "../assets/images/Donation_sucess.svg";

export default function DonationSuccess() {
  const currentUserId = getCurrentUserId();
  const { isProfileInfo } = useProfile();
  const sidebarMenus = getSidebarMenus(currentUserId);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [activeSidebar] = useState("settings");
  const [showSidebar, setShowSidebar] = useState(true);
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        <div className="prime-layout-container container-fluid">
          <div className="row">
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              onNavigate={(item) => navigate(item.path)}
            />

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="donation_success_container">
                <div className="donation_success_img">
                  <img src={DonationSuccessIcon} alt="donation_sucess" />
                  <h2>Request Submitted!</h2>
                  <span>Status : Pending Review</span>
                  <p>
                    Admin will review your details shortly. This usually takes
                    24-48 hours. We'll notify you once the process is complate
                  </p>
                  <button onClick={() => navigate("/feed/prime")}>
                    Back To Feed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
